module.exports = __webpack_public_path__ + "img/people-info4.8eb8f527.png";